import React from 'react';
import { useIntl } from 'react-intl';
import type { MusicVideoClip } from 'fym-shared/src/music24/musicVideoDoc';
import { TypedMemo } from '../../common/types';
import type { FootageView } from '../footage/footageView';
import { editorMessages } from '../messages/editorMessages';
import styles from './PreviewTag.module.scss';

interface PreviewTagProps {
  clip: MusicVideoClip | null;
  footage: FootageView | null;
}

/** The small tag of the clip on screen (design b1: "Bank · Embers at night"). */
const PreviewTagComponent: React.FC<PreviewTagProps> = ({ clip, footage }) => {
  const intl = useIntl();
  if (clip === null) {
    return null;
  }
  if (footage === null) {
    return <span className={styles.tag}>{intl.formatMessage(editorMessages.tagLoading)}</span>;
  }
  const message =
    footage.origin === 'bank'
      ? editorMessages.tagBank
      : footage.origin === 'ai'
        ? editorMessages.tagAi
        : editorMessages.tagYours;
  return <span className={styles.tag}>{intl.formatMessage(message, { label: footage.label })}</span>;
};

export const PreviewTag = TypedMemo(PreviewTagComponent);
